const Service = ({ logo, title, description }) => {
  return (
    <div className="generic-container">
      <div className="generic-logo">
        <img src={logo} alt={title} loading="lazy"/>
      </div>
      <div className="generic-title">
        <h3>{title}</h3>
      </div>
      <div className="generic-separator"/>
      <div className="generic-description service-description">
        <p>{description}</p>
      </div>
    </div>
  );
};

export default Service;